import { render } from "./AppToggle.vue?vue&type=template&id=3035b6bb&scoped=true"
import script from "./AppToggle.vue?vue&type=script&lang=js"
export * from "./AppToggle.vue?vue&type=script&lang=js"

import "./AppToggle.vue?vue&type=style&index=0&id=3035b6bb&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3035b6bb"]])

export default __exports__